import EventDispatcherModule from '@shcc/modules/EventDispatcherModule';
import { isClient } from '@shcc/utils/DeviceUtils';

const ADAPTIVE_STATE = {
  initial: 'initial',
  parsed: 'parsed',
};

class AdaptiveModule extends EventDispatcherModule {
  constructor() {
    super();
    this.state = ADAPTIVE_STATE.initial;
    this.queries = [];

    if (isClient()) {
      // Only parse on client-side
      this.parse();
    }
  }

  getActiveMediaQuery(narrowOrRegularOnly) {
    const limit = this.queries.length;

    let index;
    let query;

    for (index = 0; index < limit; index += 1) {
      query = this.queries[index];
      if (query.mediaQueryList.matches) {
        if (narrowOrRegularOnly) {
          return query.id === 'extra-narrow' || query.id === 'narrow'
            ? 'narrow'
            : 'regular';
        } else {
          return query.id;
        }
      }
    }

    if (isClient()) {
      // Try again if empty (HMR)
      this.parse({ force: true });
      return this.getActiveMediaQuery(narrowOrRegularOnly);
    }
  }

  getCSSRulesFromStyleSheet(styleSheet) {
    try {
      return styleSheet.cssRules;
    } catch (error) {
      return []; // Return empty list
    }
  }

  parse(options = {}) {
    if (this.state === ADAPTIVE_STATE.initial || options.force) {
      this.state = ADAPTIVE_STATE.parsed;
      this.parseStyleSheets();
    }
  }

  parseStyleSheets() {
    const { styleSheets } = document;
    const limit = styleSheets.length;

    let index;
    let styleSheet;

    for (index = 0; index < limit; index += 1) {
      styleSheet = styleSheets[index];
      this.parseMediaQueries(styleSheet);
    }
  }

  parseMediaQueries(styleSheet = {}) {
    const cssRules = this.getCSSRulesFromStyleSheet(styleSheet);
    const limit = cssRules ? cssRules.length : 0;

    let index;
    let cssRule;
    let match;

    for (index = 0; index < limit; index += 1) {
      cssRule = cssRules[index];
      match = /adaptive:(.+)["']/.exec(cssRule.cssText);
      if (cssRule.type === cssRule.MEDIA_RULE && match) {
        this.queries.push({
          id: match[1],
          mediaQueryList: window.matchMedia(cssRule.media.mediaText),
        });
      }
    }
  }
}

export const adaptiveModule = new AdaptiveModule();
